import { Loader } from "@googlemaps/js-api-loader";

class MapManager {
    constructor(element) {
        this.element = element;
        this.loader = new Loader({
            apiKey: this.apiKey,
            version: "weekly",
            libraries: ["maps", "marker", "core"]
        });

    }

    get menuItems() {
        if (!this._menuItems)
            this._menuItems = this.element.querySelectorAll(".c-map-row__menu-item");
        return this._menuItems;
    }

    get markerImg() {
        if (!this._markerImg)
            this._markerImg = this.element.getAttribute("data-marker-img");
        return this._markerImg;
    }

    get markerHoverImg() {
        if (!this._markerHoverImg)
            this._markerHoverImg = this.element.getAttribute("data-marker-hover-img");
        return this._markerHoverImg;
    }

    get apiKey() {
        if (!this._apiKey)
            this._apiKey = this.element.getAttribute("data-map-api-key");
        return this._apiKey;
    }

    get locations() {
        if (!this._locations)
            this._locations = JSON.parse(this.element.getAttribute("data-locations"));
        return this._locations;
    }

    get primaryLocation() {
        if (!this._primaryLocation)
            this._primaryLocation = JSON.parse(this.element.getAttribute("data-primary-location"));
        return this._primaryLocation;
    }

    async selectLocations(categoryElement) {
        const items = this.menuItems;
        for (var i = 0; i < items.length; i++) {
            if (items[i] == categoryElement)
                items[i].classList.add("active");
            else
                items[i].classList.remove("active");
        }
        this.lastSelectedCategory = categoryElement || this.lastSelectedCategory;
        let categoryName = categoryElement?.innerText;
        let activeLocations = [... this.locations
            .filter(l => !categoryName || l.categories.indexOf(categoryName) > -1), this.primaryLocation];
        let { AdvancedMarkerElement } = await this.loader.importLibrary("marker");
        let { LatLngBounds, LatLng } = await this.loader.importLibrary("core");
        let { InfoWindow } = await this.loader.importLibrary("maps");
        const bounds = new LatLngBounds();

        if (this.markers) {
            for (var marker of this.markers) {
                marker.setMap(null);
            }
        }

        this.markers = activeLocations.map(location => {
            const markerImageElement = document.createElement("img");
            markerImageElement.src = location.markerImgOverride ?? this.markerImg;
            const marker = new AdvancedMarkerElement({
                map: this.map,
                position: { lat: location.lat, lng: location.lng },
                content: markerImageElement,
                title: location.name,
            });
            const info = new InfoWindow({
                content: `<div class="info-window__content">
                <h1 class="info-window__name h6">${location.name}</h1>
                <div class="info-window__description">
                    ${location.description}
                </div>
                </div>`
            });
            marker.addListener("mouseover", () => {
                markerImageElement.src = location.markerImgOverride ?? this.markerHoverImg;
            });
            marker.addListener("mouseout", () => {
                markerImageElement.src = location.markerImgOverride ?? this.markerImg;
            });
            marker.addListener("click", () => {
                this.currentInfo?.close();
                this.currentInfo = info;
                info.open({
                    map: this.map,
                    anchor: marker,
                });
            });
            bounds.extend(marker.position);
            return marker;
        });

        if (categoryElement) {
            if (window.innerWidth > 767) {
                // Account for dead space at the left of the map
                const ne = bounds.getNorthEast();
                const sw = bounds.getSouthWest();
                const width = ne.lng() - sw.lng();
                const farLeft = new LatLng({
                    lat: sw.lat(),
                    lng: sw.lng() - width
                });
                bounds.extend(farLeft);
            } else {
                this.element.getElementsByClassName("the-map")[0].scrollIntoView();
            }
        }

        this.map.fitBounds(bounds);
        this.map.getZoom() > 19 && this.map.setZoom(19);
    }

    async initMap() {
        const items = this.menuItems;
        for (var i = 0; i < items.length; i++) {
            const item = items[i];
            item.addEventListener("click", () => {
                this.selectLocations(item);
            });
        }

        const { Map } = await this.loader.importLibrary("maps");

        const mapElement = this.element.getElementsByClassName("the-map")[0];

        this.map = new Map(mapElement, {
            mapTypeControl: false,
            mapId: this.element.getAttribute("data-map-id") ?? mapElement.id,
            center: { lat: this.primaryLocation.lat, lng: this.primaryLocation.lng },
            zoom: 8
        });

        this.selectLocations();

        this.element
            .querySelector(".c-map-row__menu-trigger")
            .addEventListener('click', (event) => this.toggleExpanded(event.target));
    }

    toggleExpanded(source) {
        const classList = this.element
            .querySelector(".c-map-row__menu")
            .classList;
        classList.toggle("expanded");
        if (classList.contains("expanded")) {
            this.selectLocations(this.lastSelectedCategory || this.menuItems[0]);
            source.setAttribute("aria-expanded", "true");
        } else {
            this.selectLocations(null);
            source.setAttribute("aria-expanded", "false");
        }
    }

    load() {
        this.loader.load().then(() => {
            this.initMap();
        });
    }

    static initializeMaps() {
        var rows = document.getElementsByClassName("c-map-row");
        for (var i = 0; i < rows.length; i++) {
            new MapManager(rows[i]).load();
        }
    }
}

export default MapManager;